import axios from 'axios';
import { getCurrentInstance} from "vue";
import { Message, Notice } from 'view-ui-plus';
import Cookies from 'js-cookie';
const env = import.meta.env.MODE;
import {onlyone} from "@/protocol/json_result.ts";
import {onlyone as page} from "@/protocol/page_result.ts";
import Json = onlyone.Json;
import Page = page.Page;
import {refresh} from "@/api/account.ts";
import {useRouter} from "vue-router";
const API_BASE = env == 'development' ? 'http://localhost:8888' : 'https://api.onlylove.cc';
// console.log("API_BASE",API_BASE);
// console.log("env",env);
// 创建一个错误
function errorCreate (msg: any) {
    const err = new Error(msg);
    errorLog(err);
    throw err;
}

let reset = false;

// 记录和显示错误
function errorLog (err: any) {
    // TODO: Add Pinia log store integration
    // console.error('Request Error:', {
    //     message: '数据请求异常',
    //     type: 'error',
    //     error: err
    // });
    // 打印到控制台
    //     console.log(err);
    // 显示提示，可配置使用 View UI Plus 的 $Message 还是 $Notice 组件来显示

    // Message.error({
    //     content: err.message,
    //     duration: 3000
    // });
}

// 创建一个 axios 实例
const service = axios.create({
    baseURL: API_BASE,
    timeout: 60 * 1000
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // console.warn("interceptors.request",config)
        let url = config.url;
        if (url && (url.indexOf("/oauth2") > -1 || url.indexOf("/account") > -1)) {
            if (reset) {
                throw new Error("授权发起中...");
            }
            reset = true;
            setTimeout(() => {
                reset = false;
            }, 5000)
        } else if (url && url.indexOf("/open") > -1) {
            config.headers['Content-Type'] = "application/octet-stream";
            config.responseType = "arraybuffer";
        } else if (url && url.indexOf('imgbb.') > -1) {

        }
        else {
            let contentType = config.headers['Content-Type']?.toString();
            let contenttype = config.headers['content-type']?.toString();
            if (!(contentType && contentType.length) || !(contenttype && contenttype.length)) {
                config.headers['Content-Type'] = "application/octet-stream";
                config.responseType = "arraybuffer"
            }
            let token = Cookies.get("token");
            config.headers['Authorization'] = token;
        }
        return config;
    },
    error => {
        // 发送失败
        // console.error(error);
        Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        // console.warn("interceptors.response",response)
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data;
        let contentType = response.headers['content-type'];
        if (contentType == "application/x-protobuf") {
            reset = false;
            const uint8Array = (dataAxios);
            let json = Json.deserializeBinary(uint8Array);
            if (json.success) {
                return json.data;
            } else {
                errorCreate(json.message)
            }
            return
        }
        // 这个状态码是和后端约定的
        const { success, code } = dataAxios;
        // 根据 code 进行判断
        if (success === undefined) {
            let url = response.config.url;
            // 如果没有 code 代表这不是项目后端开发的接口
            reset = false;
            if (url && url!!.indexOf("oauth2/token") > -1) {
                let oldData = response.config.data;
                if (oldData.indexOf("refresh_token") > -1) {// 交换请求
                    if (dataAxios.error) {
                        errorCreate("登录超时，请重新登录...")
                        return dataAxios;
                    }
                } else {// 登录请求
                    let contentType = response.headers['content-type'];
                    if (contentType.indexOf('application/json') > -1) {
                        if (dataAxios.error) {
                            if (dataAxios.error_description.indexOf('password') > -1) {
                                errorCreate("账号或密码不正确");
                            }
                            errorCreate(dataAxios.error_description+"");
                        }
                    } else if (contentType.indexOf('text/html') > -1)  {
                        errorCreate("账号不存在.")
                        return {};
                    }
                }
                return dataAxios;
            }
            if (url && url!!.indexOf("oauth2/revoke") > -1) {
                let error1 = dataAxios.error;
                if (error1) {
                    errorCreate(error1);
                }
                return dataAxios;
            }
            if (url && url!!.indexOf("account/register") > -1) {
                let contentType = response.headers['content-type'];
                if (contentType.indexOf('text/html') > -1) {
                    errorCreate("注册失败");
                }
            }
            return dataAxios;
        } else {
            if (!success) {
                errorCreate(dataAxios.message);
            }
            return dataAxios;
        }
    },
    async error => {
        // console.warn("interceptors.response error",error.response.status)
        // console.warn("interceptors.response error",error.response)
        let response = error.response;
        if (!response) {
            let err = new Error(error);
            return Promise.reject(err);
        }
        if (response.status == 401) {
            reset = false;
            let contentType = response.headers['content-type'];
            if (response.config.url.indexOf('/oauth2') > -1) {
                let dataParam = response.data;
                if (dataParam.grant_type == 'refresh_token') {
                    error.message = "请求失败，交换中...";
                    return Promise.reject(error);
                } else {
                    if (contentType.indexOf("/json") > -1) {
                        error.message = response.data.error;
                    } else {
                        error.message = "未知异常";
                    }
                    return Promise.reject(error);
                }
            }
            if (response.config.url.indexOf('/oauth2') < 0) {
                if (reset) {
                    error.message = "请求失败，交换中...";
                    return Promise.reject(error);
                }
                let refreshToken = Cookies.get("refresh");
                if (refreshToken) {
                    try {
                        let response = await refresh(refreshToken);
                        if (response.access_token) {
                            Cookies.set("token", `${response.token_type} ${response.access_token}`);
                            error.message = "请求超时，请重试";
                            return Promise.reject(error);
                        } else {
                            error.message = "登录超时，请重新登录...";
                            return Promise.reject(error);
                        }
                    } catch (e) {
                        error.message = "登录超时，请重新登录...";
                        return Promise.reject(error);
                    }
                }
            }
        }
        if (response.status == 302) {
            if (response.config.url.indexOf('/oauth2') > -1) {
                error.message = '账号已被锁定';
            }
        }
        if (error && response) {
            switch (response.status) {
            case 400: error.message = '请求错误'; break;
            case 401: error.message = '未授权，请登录'; break;
            case 403: error.message = '拒绝访问'; break;
            case 404: error.message = `请求地址出错: ${response.config.url}`; break;
            case 408: error.message = '请求超时'; break;
            case 500: error.message = '服务器内部错误'; break;
            case 501: error.message = '服务未实现'; break;
            case 502: error.message = '网关错误'; break;
            case 503: error.message = '服务不可用'; break;
            case 504: error.message = '网关超时'; break;
            case 505: error.message = 'HTTP版本不受支持'; break;
            default: break;
            }
        }
        errorLog(error);
        return Promise.reject(error);
    }
);

export default service;
